// id strings for messages/library.ts. Same keys and {variables} as en there.
// Indonesian puts the modifier after the noun ("suara AI anime"), so the hub
// strings use {category} as is; category names are lower-case mid-sentence.
import type { Dict } from "../index";

const library: Dict = {
  "library.of": "{name}",
  "library.ofLanguage": "bahasa {name}",

  "library.seo.title": "Library Suara AI{filter} | Jammable",
  "library.seo.titleFiltered": "Library Suara AI {filter} | Jammable",
  "library.seo.description":
    "Jelajahi 93.000+ model suara AI. Buat cover AI dengan suara dari anime, game, kartun, K-pop, dan lainnya. Suara baru ditambahkan setiap hari.",
  "library.seo.ogDescription":
    "Jelajahi 93.000+ model suara AI. Buat cover AI dengan suara dari anime, game, kartun, K-pop, dan lainnya.",
  "library.seo.listDescription":
    "Suara AI Jammable. Pembuat Cover Lagu AI. Teks ke Suara. Teknologi AI Tercanggih. 50.000+ Suara Cover AI.",
  "library.seo.listDescriptionFiltered":
    "Suara AI {filter}. Pembuat Cover Lagu AI {filter}. Teks ke Suara. Teknologi AI Tercanggih. 50.000+ Suara Cover AI.",
  "library.crumb.home": "Beranda",
  "library.crumb.library": "Library Suara AI",
  "library.crumb.filter": "Suara {category}",

  "library.title": "Library suara",
  "library.subtitle":
    "93.000+ suara. Ketuk salah satu untuk mendengarnya, atau langsung bikin cover.",
  "library.train": "Latih suaramu sendiri",
  "library.search": "Cari suara",
  "library.searchIn": "Cari suara {categoryLower}",
  "library.categoriesNav": "Kategori suara",
  "library.all": "Semua",
  "library.moreCategories": "Kategori lainnya",
  "library.fewerCategories": "Lebih sedikit kategori",
  "library.collections": "Koleksi",
  "library.collections.prev": "Koleksi sebelumnya",
  "library.collections.next": "Koleksi lainnya",
  "library.collection.voices": "{n} suara",
  "library.voicesIn": "Suara {category}",
  "library.allVoices": "Semua suara",
  "library.empty.title": "Suara tidak ditemukan",
  "library.empty.body": "Coba nama lain, atau latih sendiri suaranya.",
  "library.loadMore": "Muat suara lainnya",

  "library.sort.aria": "Urutkan suara",
  "library.sort.hot": "Trending hari ini",
  "library.sort.hot.short": "Trending",
  "library.sort.top": "Paling banyak dipakai",
  "library.sort.top.short": "Terpopuler",
  "library.sort.liked": "Paling disukai",
  "library.sort.liked.short": "Paling disukai",
  "library.sort.new": "Terbaru",
  "library.sort.new.short": "Terbaru",

  "library.hub.title":
    "Suara AI {category}: Buat Cover AI dengan Suara {category} | Jammable",
  "library.hub.titlePage": "Suara AI {category}, Halaman {page} | Jammable",
  "library.hub.description":
    "Jelajahi {count}+ suara AI {category} di Jammable. Pilih suara mana pun untuk membuat cover AI atau pakai pengubah suara AI.",
  "library.hub.descriptionPage":
    "Halaman {page} dari {lastPage} suara AI {category} di Jammable, diurutkan berdasarkan jumlah pemakaian. Pilih suara mana pun untuk membuat cover AI atau pakai pengubah suara AI.",
  "library.hub.name": "Suara AI {category}",
  "library.hub.crumbVoices": "Suara AI",
  "library.hub.voices": "Suara",
  "library.hub.page": "Halaman {page}",
  "library.hub.h1": "Suara AI {category}",
  "library.hub.intro":
    "Jelajahi {count}+ suara AI {category}. Pilih salah satu untuk membuat cover AI, atau pakai sebagai pengubah suara.",
  "library.hub.popular": "Suara {categoryLower} populer",
  "library.hub.mostUsedPage":
    "Suara {categoryLower} paling banyak dipakai, halaman {page} dari {lastPage}",
  "library.hub.noMatch":
    "Tidak ada suara {categoryLower} yang cocok dengan pencarian itu.",
  "library.hub.openLibrary": "Buka di library suara",
  "library.hub.moreCategories": "Jelajahi kategori lainnya",
  "library.hub.faq": "Pertanyaan yang sering diajukan",
  "library.hub.keepExploring": "Jelajahi terus",
  "library.hub.moreWays": "Cara lain untuk berkreasi dengan Jammable.",
  "library.hub.link.aiCover": "Pembuat Cover AI",
  "library.hub.link.voiceChanger": "Pengubah Suara AI",
  "library.hub.link.allVoices": "Jelajahi semua suara AI",
  "library.hub.pages": "Halaman",
  "library.hub.first": "Pertama",
  "library.hub.prev": "Sebelumnya",
  "library.hub.next": "Berikutnya",
  "library.hub.last": "Terakhir",
  "library.hub.faq1.q": "Apa itu suara AI {category}?",
  "library.hub.faq1.a":
    "Suara AI {category} adalah model suara dalam kategori {categoryLower} yang bisa kamu pakai untuk membuat cover AI atau mengubah suaramu sendiri. Jammable punya {count}+ suara seperti ini, dan suara baru ditambahkan setiap hari.",
  "library.hub.faq2.q": "Bagaimana cara memakai suara AI {category}?",
  "library.hub.faq2.a":
    "Buka suara {category} mana pun, tambahkan audio yang kamu punya haknya (atau rekam suaramu sendiri), lalu tekan buat. Jammable mengubah vokalnya ke suara tersebut dan memberikan cover yang sudah jadi dalam hitungan detik.",
  "library.hub.faq3.q": "Ada berapa suara {category}?",
  "library.hub.faq3.a":
    "Saat ini Jammable punya {count}+ suara AI {category}, dan library-nya terus bertambah setiap hari karena komunitas mengunggah dan melatih suara baru.",

  "library.cat.public-figure": "tokoh publik",
  "library.cat.music": "musik",
  "library.cat.cartoon": "kartun",
  "library.cat.gaming": "gaming",
  "library.cat.fictional": "karakter fiksi",
  "library.cat.anime": "anime",
  "library.cat.influencer": "influencer",
  "library.cat.singer": "penyanyi",
  "library.cat.comedy": "komedi",
  "library.cat.pop": "pop",
  "library.cat.youtuber": "YouTuber",
  "library.cat.tv-show": "acara TV",
  "library.cat.rap": "rap",
  "library.cat.fictional-character": "karakter fiksi",
  "library.cat.movie": "film",
  "library.cat.movies": "film",
  "library.cat.funny": "lucu",
  "library.cat.kpop": "K-pop",
  "library.cat.k-pop": "K-pop",
  "library.cat.parody": "parodi",
  "library.cat.animation": "animasi",
  "library.cat.animated": "animasi",
  "library.cat.rock": "rock",
  "library.cat.vtuber": "VTuber",
  "library.cat.fantasy": "fantasi",
  "library.cat.game": "game",
  "library.cat.entertainment": "hiburan",
  "library.cat.rapper": "rapper",
  "library.cat.horror": "horor",
  "library.cat.actor": "aktor",
  "library.cat.actors": "aktor",
  "library.cat.actress": "aktris",
  "library.cat.meme": "meme",
  "library.cat.action": "aksi",
  "library.cat.educational": "edukasi",
  "library.cat.hip-hop-rap": "hip-hop/rap",
  "library.cat.hip-hop": "hip-hop",
  "library.cat.adventure": "petualangan",
  "library.cat.tv": "TV",
  "library.cat.female": "perempuan",
  "library.cat.male": "laki-laki",
  "library.cat.superhero": "superhero",
  "library.cat.drama": "drama",
  "library.cat.sci-fi": "fiksi ilmiah",
  "library.cat.science-fiction": "fiksi ilmiah",
  "library.cat.alternative": "musik alternatif",
  "library.cat.metal": "metal",
  "library.cat.technology": "teknologi",
  "library.cat.indie": "indie",
  "library.cat.celebrity": "selebriti",
  "library.cat.fiction": "fiksi",
  "library.cat.american": "Amerika",
  "library.cat.british": "Inggris",
  "library.cat.australian": "Australia",
  "library.cat.latino": "Latin",
  "library.cat.mexico": "Meksiko",
  "library.cat.villain": "penjahat",
  "library.cat.politics": "politik",
  "library.cat.president": "presiden",
  "library.cat.animal": "hewan",
  "library.cat.animals": "hewan",
  "library.cat.dog": "anjing",
  "library.cat.cat": "kucing",
  "library.cat.sports": "olahraga",
  "library.cat.wrestling": "gulat",
  "library.cat.streamer": "streamer",
  "library.cat.country": "country",
  "library.cat.robot": "robot",
  "library.cat.sound-effects": "efek suara",
  "library.cat.historical": "tokoh sejarah",
  "library.cat.folk": "folk",
  "library.cat.r-b": "R&B",
  "library.cat.rnb": "R&B",
  "library.cat.jazz": "jazz",
  "library.cat.reggaeton": "reggaeton",
  "library.cat.electronic": "musik elektronik",
  "library.cat.pop-music": "musik pop",
  "library.cat.comic": "komik",
  "library.cat.demon": "iblis",
  "library.cat.news": "berita",
  "library.cat.artist": "artis",
  "library.cat.artistas": "artis",
  "library.cat.cantantes": "penyanyi",
  "library.cat.cantante": "penyanyi",
  "library.cat.personajes": "karakter",
  "library.cat.character": "karakter",
  "library.cat.singing": "nyanyian",
  "library.cat.mystery": "misteri",
  "library.cat.christmas": "Natal",
  "library.cat.sitcom": "sitkom",
  "library.cat.pirate": "bajak laut",
  "library.cat.toy": "mainan",
  "library.cat.classic": "klasik",
  "library.cat.art": "seni",
  "library.cat.poetry": "puisi",
  "library.cat.food": "makanan",
  "library.cat.fashion": "fashion",
  "library.cat.family": "keluarga",
  "library.cat.podcast": "podcast",
  "library.cat.radio": "radio",
  "library.cat.ai": "AI",
  "library.cat.artificial-intelligence": "kecerdasan buatan",
  "library.cat.song": "lagu",
  "library.cat.ringtone": "nada dering",
  "library.cat.web-series": "serial web",
  "library.cat.idol": "idol",
  "library.cat.dub": "dubbing",
  "library.cat.80s": "era 80-an",
  "library.cat.indie-games": "game indie",
  "library.cat.game-show": "game show",
  "library.lang.japanese": "Jepang",
  "library.lang.japenese": "Jepang",
  "library.lang.korean": "Korea",
  "library.lang.spanish": "Spanyol",
  "library.lang.english": "Inggris",
  "library.lang.french": "Prancis",
  "library.lang.italian": "Italia",
  "library.lang.german": "Jerman",
  "library.lang.deutsch": "Jerman",
  "library.lang.russian": "Rusia",
  "library.lang.hebrew": "Ibrani",
  "library.lang.chinese": "Mandarin",
  "library.lang.arabic": "Arab",
  "library.lang.swedish": "Swedia",
  "library.lang.polish": "Polandia",
  "library.lang.turkish": "Turki",
  "library.lang.finnish": "Finlandia",
  "library.lang.greek": "Yunani",
  "library.lang.indonesian": "Indonesia",
  "library.lang.thai": "Thailand",
  "library.lang.hungarian": "Hongaria",
  "library.lang.filipino": "Filipina",
  "library.lang.malaysian": "Malaysia",
  "library.lang.portuguese": "Portugis",
  "library.lang.brasileiro": "Portugis Brasil",
  "library.lang.pt-br": "Portugis Brasil",
  "library.lang.romanian": "Rumania",
  "library.lang.hindi": "Hindi",
  "library.lang.dutch": "Belanda",
  "library.lang.czech": "Ceko",
  "library.lang.vietnamese": "Vietnam",
};

export default library;
